interface WrapResult {
  nextText: string;
  selectionStart: number;
  selectionEnd: number;
}

function stripMarkers(text: string, marker: string): string {
  const escaped = marker.replace(/\*/g, '\\*')
  const re = new RegExp(escaped, 'g')
  return text.replace(re, '')
}

export function wrapMarkdownBold(text: string, start: number, end: number): WrapResult {
  const sel = text.slice(start, end)

  if (sel.startsWith("**") && sel.endsWith("**") && sel.length > 4) {
    const inner = sel.slice(2, -2)
    const nextText = text.slice(0, start) + inner + text.slice(end)
    return { nextText, selectionStart: start, selectionEnd: start + inner.length }
  }

  const cleaned = sel.length > 0 ? stripMarkers(sel, "**") : "bold"
  const wrapped = `**${cleaned}**`
  const nextText = text.slice(0, start) + wrapped + text.slice(end)
  return { nextText, selectionStart: start + 2, selectionEnd: start + 2 + cleaned.length }
}

export function wrapMarkdownItalic(text: string, start: number, end: number): WrapResult {
  const sel = text.slice(start, end)

  if (sel.length > 2 && sel.startsWith("*") && sel.endsWith("*") && !sel.startsWith("**")) {
    const inner = sel.slice(1, -1)
    const nextText = text.slice(0, start) + inner + text.slice(end)
    return { nextText, selectionStart: start, selectionEnd: start + inner.length }
  }

  const cleaned = sel.length > 0 ? stripMarkers(sel, "*") : "italic"
  const wrapped = `*${cleaned}*`
  const nextText = text.slice(0, start) + wrapped + text.slice(end)
  return { nextText, selectionStart: start + 1, selectionEnd: start + 1 + cleaned.length }
}
